import { getClients } from '@/data/site';
import { useLiveTick } from '@/lib/liveContent';
import { cn } from '@/lib/utils';

const Wordmark = ({ client, dupe }) => {
  if (client.imageSrc) {
    return (
      <img
        src={client.imageSrc}
        alt={dupe ? '' : client.alt || `${client.name} logo`}
        aria-hidden={dupe ? 'true' : undefined}
        loading="lazy"
        className={cn('h-8 w-auto whitespace-nowrap opacity-60 transition-opacity duration-300 hover:opacity-100 sm:h-9', dupe && 'marquee-dupe')}
      />
    );
  }
  return (
    <span
      aria-hidden={dupe ? 'true' : undefined}
      className={cn(
        'whitespace-nowrap text-xl text-slate-400 transition-colors duration-300 hover:text-navy-900 sm:text-2xl',
        dupe && 'marquee-dupe',
        client.className
      )}
    >
      {client.name}
    </span>
  );
};

export const ClientLogos = () => {
  useLiveTick();
  const CLIENTS = getClients();
  return (
  <section aria-labelledby="clients-heading" data-testid="clients-section" className="border-y border-slate-100 bg-white py-16 sm:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-center gap-4">
        <span className="font-mono text-xs font-medium tracking-widest text-gold-700">02</span>
        <h2 id="clients-heading" className="text-sm font-bold uppercase tracking-[0.24em] text-navy-900">
          Our Clients
        </h2>
      </div>

      <div className="marquee relative mt-10 overflow-hidden" data-testid="marquee-container">
        <div className="marquee-track flex w-max items-center gap-16 pr-16 sm:gap-24 sm:pr-24">
          {CLIENTS.map((c) => (
            <Wordmark key={c.name} client={c} />
          ))}
          {CLIENTS.map((c) => (
            <Wordmark key={`dupe-${c.name}`} client={c} dupe />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-white [mask-image:linear-gradient(to_right,black,transparent)]" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-white [mask-image:linear-gradient(to_left,black,transparent)]" aria-hidden="true" />
      </div>
    </div>
  </section>
  );
};
